// extracted by mini-css-extract-plugin
export default {"root":"_1uCPx","icon":"_3EH51"};